import { Inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FeedbackGateway } from '@prlw/core/feedback/feedback-gateway.interface';
import { SendFeedbackResponse } from '@prlw/data/feedback/api-types/send.api';
import { FEEDBACK_DATA_CONFIG } from '@prlw/data/feedback/feedback-data-config.token';
import { FeedbackDataConfig } from '@prlw/data/feedback/feedback-data.module';
import { Feedback } from '@prlw/core/feedback/feedback.entity';
import {
  TFileUploadResponse,
  TUploadResult,
} from '@prlw/libs/file-upload/types';
import { mapEventsProgress } from '@prlw/libs/file-upload/map-events-progress';

@Injectable({
  providedIn: 'root',
})
export class HttpFeedbackGateway implements FeedbackGateway {
  constructor(
    @Inject(FEEDBACK_DATA_CONFIG) private readonly config: FeedbackDataConfig,
    private readonly http: HttpClient,
  ) {}

  public sendFeedback(data: Feedback): Observable<SendFeedbackResponse> {
    return this.http
      .post<SendFeedbackResponse>(this.config.apiPrefix, data)
      .pipe(
        map(() => ({ success: true, error: null })),
        catchError((errorResponse: HttpErrorResponse) =>
          of({
            success: false,
            error: errorResponse.error.message,
          }),
        ),
      );
  }

  public fileUpload(
    formData: FormData,
  ): Observable<TFileUploadResponse<TUploadResult>> {
    return this.http
      .post<TUploadResult>(`${this.config.apiPrefix}/file_upload`, formData, {
        observe: 'events',
        reportProgress: true,
        headers: new HttpHeaders({
          Accept: `application/json, text/plain, */*`,
        }),
      })
      .pipe(mapEventsProgress);
  }
}
